// https://github.com/timmywil/panzoom

import React, { Component } from "react";
import Menu from "./Menu";
import { observer, inject } from "mobx-react";
import MapPoints from "./MapPoints";
import { withRouter } from "react-router-dom";
import Popup from "./Popup";
import { observable } from "mobx";
import Panzoom from "./Panzoom";

@inject("store")
@observer
class CityMap extends Component {
  @observable initialLoad = true;
  @observable mapTransform = {};
  @observable mapPointActions = {};

  componentDidMount() {
    // set the route params on load
    // and when any history changes
    this.setRouteParams(this.props.location.pathname);
    this.props.history.listen(event => this.setRouteParams(event.pathname));

    // auto select layer from router (deep-linking)
    this.props.store.setLayer(this.props.store.layer || null);

    // auto zoom to the data point from router (deep-linking)
    setTimeout(() => {
      this.goToPoint(this.props);
    }, 200);
  }

  /**
   * React to any new props when the router changes
   */
  setRouteParams(url) {
    const paths = url.split("/").filter(Boolean);
    this.props.store.layer = paths[0];
    this.props.store.point = paths[1];
    this.props.store.popup = paths[2];
    this.goToPoint();
  }

  /**
   * Finds a point by it's ID and zooms/pans to it
   */
  goToPoint() {
    if (this.props.store.point) {
      const point = this.props.store.points.find(o => o.id == this.props.store.point);
      if (!point) return;
      this.panzoom.zoomToPoint(2, { x: point.x, y: point.y }, { animate: true });
      // ga("send", "event", "LB City", point.label, "Zoom To POI");
      dataLayer.push({
        'event': 'gaEvent',
        'eventCategory': 'LB City - ' + this.props.store.layer,
        'eventAction': "Zoom To POI",
        'eventLabel': point.label
      });
    }
  }

  handlePanzoomChange = ({ x, y, scale }) => {
    this.mapTransform = { x, y, scale };
  };

  // the Panzoom component sends back a click event for anything within the map
  // becasue PointTracker stops all event propagation
  // we need to pass this down to the MapPoint actions event
  // add additional child component events here
  handlePanzoomClick(event) {
    this.mapPointActions.click(event);
  }

  // used to capture the actions from MapPoint component
  // becasue PointTracker stops all event propagation
  // we need a handle to the child component click events
  handleMapActions(actions) {
    this.mapPointActions = actions;
  }

  render() {
    let region = localStorage.getItem("zennerOrSensus");
    return (
      <>
        <Menu
          onLogoClick={() => {
            this.panzoom.reset();
          }}
        />

        <div className={`map-loader ${this.props.store.loading ? "show" : "hide"}`}>
          <div className="map-loader--logos">
            <img src="/city/assets/loading-logos.png" alt="" />
          </div>
          <div className="map-loader--img">
            <img src="/city/assets/loading.gif" alt="" />
            <div className="map-loader--text">Loading Map</div>
          </div>
        </div>
        <div className="map-logos">
          <img src="/city/assets/540.png" className="map-logos--desktop" onClick={() => window.open('https://www.540technologies.com/', "_blank")} />
          <img src="/city/assets/lb.png" className="map-logos--desktop" onClick={() => window.open('/', "_blank")} />
          <img src="/city/assets/s3.png" className="map-logos--desktop" onClick={() => window.open('https://www.s3usa.com/', "_blank")} />
          {/* <img src="/city/assets/map-logos.jpg" className="map-logos--desktop" onClick={() => window.location.href = "/"} /> */}
          <img src="/city/assets/map-logos-mobile.jpg" className="map-logos--mobile" alt="" onClick={() => window.open('/', "_blank")} />
        </div>
        <div className="map-copyright">&copy; {new Date().getFullYear()} LB WATER. ALL RIGHT RESERVED</div>
        <div id="map-container">
          <Panzoom
            height={3240}
            width={5760}
            scale={0}
            x={0}
            y={0}
            id="map-base"
            className="map-bg"
            classNameAfterLoad={this.props.store.layer && `map-layer--${this.props.store.layer == "smart" && region == "Zenner" ? "smartz" :  this.props.store.layer }`}
            actions={actions => (this.panzoom = actions)}
            onChange={this.handlePanzoomChange}
            onClick={this.handlePanzoomClick.bind(this)}
          >
            <MapPoints
              actions={this.handleMapActions.bind(this)}
              onClickPoint={point => {
                this.props.history.push(`/${this.props.store.layer}/${point.id}`);
              }}
              onClickPopup={point => {
                this.props.history.push(`/${this.props.store.layer}/${point.id}/popup`);
              }}
            />
          </Panzoom>
        </div>

        <Popup transform={this.mapTransform} />
      </>
    );
  }
}

export default withRouter(CityMap);
